import React from 'react';
import { Link, Navigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { register } from '../../containers/RegisterPage/actions';
import { selectUser } from '../../containers/App/selectors';
import V2PublicAuthShell from '../components/V2PublicAuthShell';

const V2Register: React.FC = () => {
  const { t } = useTranslation('translation');
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const [searchParams] = useSearchParams();
  const refFromUrl = searchParams.get('ref') ?? '';

  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [confirm, setConfirm] = React.useState('');
  const [referralCode, setReferralCode] = React.useState(refFromUrl);
  const [error, setError] = React.useState('');

  if (user) {
    return <Navigate to="/statistics" replace />;
  }

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!email.trim()) {
      setError('Введите email.');
      return;
    }
    if (!/\S+@\S+\.\S+/.test(email)) {
      setError('Некорректный email.');
      return;
    }
    if (!password) {
      setError('Введите пароль.');
      return;
    }
    if (password !== confirm) {
      setError(t('passwords_do_not_match'));
      return;
    }

    setError('');
    dispatch(
      register({
        email: email.trim(),
        password,
        referralCode: referralCode.trim() || undefined,
      }),
    );
  };

  return (
    <V2PublicAuthShell
      title={t('sign_up')}
      subtitle="Создайте аккаунт Fish Hunter."
      footer={
        <div className="signup-row">
          <span>{t('already_have_an_account')}</span>
          <Link to="/">
            Войти <span aria-hidden="true">↗</span>
          </Link>
        </div>
      }
    >
      <form noValidate onSubmit={handleSubmit}>
        <label htmlFor="register-email">Email</label>
        <input
          id="register-email"
          type="email"
          placeholder="you@example.com"
          autoComplete="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        />

        <label htmlFor="register-password">{t('password')}</label>
        <input
          id="register-password"
          type="password"
          placeholder={t('password')}
          autoComplete="new-password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
        />

        <label htmlFor="register-confirm">{t('confirm_password')}</label>
        <input
          id="register-confirm"
          type="password"
          placeholder={t('confirm_password')}
          autoComplete="new-password"
          value={confirm}
          onChange={(event) => setConfirm(event.target.value)}
        />

        <label htmlFor="register-ref">{t('referral_code')}</label>
        <input
          id="register-ref"
          type="text"
          placeholder={t('referral_code')}
          autoComplete="off"
          value={referralCode}
          onChange={(event) => setReferralCode(event.target.value)}
        />

        {error ? (
          <span className="field-error" aria-live="polite">
            {error}
          </span>
        ) : null}

        <button className="login-submit" type="submit">
          {t('sign_up')} <span aria-hidden="true">↗</span>
        </button>
      </form>
    </V2PublicAuthShell>
  );
};

export default V2Register;
